import React from "react";
import { useDelete } from "../../../../../../api/useCall";
import t from "../../../../../../i18n";
import ModalForm from "@ui/Modal/Form";
import Text from "@ui/Text";
import AdditionnalMessage from "@ui/AdditionnalMessage";

interface P {
  projectId: string;
  onRequestClose: () => void;
}

export const DeleteCrossFiltersModalForm = ({ onRequestClose, projectId }: P) => {
  const resetCrossFilters = useDelete("/projects/:projectId(uuid)/cross-filters/reset");

  const handleSubmit = React.useCallback(async () => {
    await resetCrossFilters({
      routeParams: { projectId },
    });
    onRequestClose();
    return true;
  }, [resetCrossFilters, projectId, onRequestClose]);

  return (
    <ModalForm
      onRequestClose={onRequestClose}
      onSubmit={handleSubmit}
      okButtonName={t("quantities.cross_filter.modale.delete.button_name")}
      okButtonVariant="destructive"
    >
      <Text>{t("quantities.cross_filter.modale.delete.question")}</Text>
      <AdditionnalMessage
        status="WARNING"
        text={t("quantities.cross_filter.modal.delete.additionnal_message.warning")}
      />
    </ModalForm>
  );
};

export default React.memo(DeleteCrossFiltersModalForm);
